import { useTranslation } from "react-i18next";

const importBlogImages = (imageName: string) => {
  try {
    return require(`../../assets/blogs/${imageName}.png`);
  } catch (e) {
    return "";
  }
};

const importInitialImagesBlogs = (imageName: string) => {
  try {
    return require(`../../assets/blogs/${imageName}.png`);
  } catch (e) {
    return "";
  }
};

// Resumo do card (começo do artigo, sem marcação) e tempo de leitura estimado (200 palavras por minuto).
function articleMeta(sections: unknown) {
  const list = Array.isArray(sections) ? (sections as { content?: string }[]) : [];
  const text = list
    .map((section) => section.content ?? "")
    .join(" ")
    .replace(/\*\*/g, "")
    .replace(/•/g, "")
    .replace(/\s+/g, " ")
    .trim();
  const words = text ? text.split(" ").length : 0;
  const excerpt = text.length > 160 ? `${text.slice(0, 160).replace(/\s+\S*$/, "")}…` : text;
  return { excerpt, minutes: Math.max(1, Math.round(words / 200)) };
}

export function useBlogTitles() {
  const { t } = useTranslation();
  const posts = [
    {
      id: 1,
      titulo: t("blog.posts.post1.title"),
      descricao: t("blog.posts.post1.description"),
      data: t("blog.posts.post1.date"),
      rawDate: "2025-07-16",
      imagem: importInitialImagesBlogs('artigo1'),
    },
    {
      id: 2,
      titulo: t("blog.posts.post2.title"),
      descricao: t("blog.posts.post2.description"),
      data: t("blog.posts.post2.date"),
      rawDate: "2025-09-22",
      imagem: importInitialImagesBlogs('artigo2'),
    },
    {
      id: 3,
      titulo: t("blog.posts.post3.title"),
      descricao: t("blog.posts.post3.description"),
      data: t("blog.posts.post3.date"),
      rawDate: "2025-10-05",
      imagem: importInitialImagesBlogs('artigo3'),
    },
    {
      id: 4,
      titulo: t("blog.posts.post4.title"),
      descricao: t("blog.posts.post4.description"),
      data: t("blog.posts.post4.date"),
      rawDate: "2024-12-18",
      imagem: importInitialImagesBlogs('artigo4'),
    },
    {
      id: 5,
      titulo: t("blog.posts.post5.title"),
      descricao: t("blog.posts.post5.description"),
      data: t("blog.posts.post5.date"),
      rawDate: "2024-12-17",
      imagem: importInitialImagesBlogs('artigo5'),
    },
    {
      id: 6,
      titulo: t("blog.posts.post6.title"),
      descricao: t("blog.posts.post6.description"),
      data: t("blog.posts.post6.date"),
      rawDate: "2025-10-05",
      imagem: importInitialImagesBlogs('artigo6'),
    },
    {
      id: 7,
      titulo: t("blog.posts.post7.title"),
      descricao: t("blog.posts.post7.description"),
      data: t("blog.posts.post7.date"),
      rawDate: "2024-07-05",
      imagem: importInitialImagesBlogs('artigo7'),
    },
    {
      id: 8,
      titulo: t("blog.posts.post8.title"),
      descricao: t("blog.posts.post8.description"),
      data: t("blog.posts.post8.date"),
      rawDate: "2023-03-24",
      imagem: importInitialImagesBlogs('artigo8'),
    },
    {
      id: 9,
      titulo: t("blog.posts.post9.title"),
      descricao: t("blog.posts.post9.description"),
      data: t("blog.posts.post9.date"),
      rawDate: "2025-10-05",
      imagem: importInitialImagesBlogs('artigo9'),
    },
    {
      id: 10,
      titulo: t("blog.posts.post10.title"),
      descricao: t("blog.posts.post10.description"),
      data: t("blog.posts.post10.date"),
      rawDate: "2025-12-12",
      imagem: importInitialImagesBlogs('artigo10'),
    },
    {
      id: 11,
      titulo: t("blog.posts.post11.title"),
      descricao: t("blog.posts.post11.description"),
      data: t("blog.posts.post11.date"),
      rawDate: "2026-03-10",
      imagem: importInitialImagesBlogs('artigo11'),
    },
    {
      id: 12,
      titulo: t("blog.posts.post12.title"),
      descricao: t("blog.posts.post12.description"),
      data: t("blog.posts.post12.date"),
      rawDate: "2026-05-04",
      imagem: importInitialImagesBlogs('artigo12'),
    },
    {
      id: 13,
      titulo: t("blog.posts.post13.title"),
      descricao: t("blog.posts.post13.description"),
      data: t("blog.posts.post13.date"),
      rawDate: "2026-04-28",
      imagem: importInitialImagesBlogs('artigo13'),
    }
  ];

  return posts
    .map((post) => ({ ...post, ...articleMeta(t(`blog.articles.article${post.id}`, { returnObjects: true })) }))
    .sort((a, b) => new Date(b.rawDate).getTime() - new Date(a.rawDate).getTime());
}

export function useBlogContent() {
  const { t } = useTranslation();
  
  // This helper maps content from i18n to the structure expected by the component
  const getArticleContent = (id: number) => {
    // If we have content specifically for this article in the JSON, use it
    const article = t(`blog.articles.article${id}`, { returnObjects: true });
    if (Array.isArray(article)) {
      return article;
    }
    
    // Fallback or handle cases where translation is missing
    return [
      {
        subtitle: "",
        content: t("blog.read_more")
      }
    ];
  };

  return [
    {
      id: 1,
      title: t("blog.posts.post1.title"),
      image: importBlogImages('blogimage1'),
      content: getArticleContent(1)
    },
    {
      id: 2,
      title: t("blog.posts.post2.title"),
      image: importBlogImages('blogimage2'),
      content: getArticleContent(2)
    },
    {
      id: 3,
      title: t("blog.posts.post3.title"),
      image: importBlogImages('blogimage3'),
      content: getArticleContent(3)
    },
    {
      id: 4,
      title: t("blog.posts.post4.title"),
      image: importBlogImages('blogimage4'),
      content: getArticleContent(4)
    },
    {
      id: 5,
      title: t("blog.posts.post5.title"),
      image: importBlogImages('blogimage5'),
      content: getArticleContent(5)
    },
    {
      id: 6,
      title: t("blog.posts.post6.title"),
      image: importBlogImages('blogimage6'),
      content: getArticleContent(6)
    },
    {
      id: 7,
      title: t("blog.posts.post7.title"),
      image: importBlogImages('blogimage7'),
      content: getArticleContent(7)
    },
    {
      id: 8,
      title: t("blog.posts.post8.title"),
      image: importBlogImages('blogimage8'),
      content: getArticleContent(8)
    },
    {
      id: 9,
      title: t("blog.posts.post9.title"),
      image: importBlogImages('blogimage9'),
      content: getArticleContent(9)
    },
    {
      id: 10,
      title: t("blog.posts.post10.title"),
      image: importBlogImages('blogimage10'),
      content: getArticleContent(10)
    },
    {
      id: 11,
      title: t("blog.posts.post11.title"),
      image: importBlogImages('blogimage11'),
      content: getArticleContent(11)
    },
    {
      id: 12,
      title: t("blog.posts.post12.title"),
      image: importBlogImages('blogimage12'),
      content: getArticleContent(12)
    },
    {
      id: 13,
      title: t("blog.posts.post13.title"),
      image: importBlogImages('blogimage13'),
      content: getArticleContent(13)
    }
  ];
}
